import React, { Component } from 'react';

class IconNoDataBackground extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="108"
                height="104"
                fill="none"
                viewBox="0 0 108 104"
            >
                <path
                    fill="#E6EEF5"
                    fillRule="evenodd"
                    d="M61.635 12.16c14.653.71 31.297-15.669 41.954-5.648 10.6 9.967-3.819 27.196-3.616 41.697.21 14.947 13.363 30.584 4.8 42.873-8.846 12.694-27.607 11.759-43.138 12.145-16.087.399-33.41.775-45.347-9.95C3.936 82.18.563 64.757.398 48.209.23 31.465.883 10.77 15.379 2.237c14.109-8.305 29.877 9.128 46.256 9.922z"
                    clipRule="evenodd"
                ></path>
            </svg>
        );
    }
}

export default IconNoDataBackground;